import { formatLongDate } from "@repo/utils/date";

import InformationRow from "../StyledComponents/InformationRow";

type Props = {
  carPickUpDate: Date;
};

function DateTimeSection({ carPickUpDate }: Props) {
  return (
    <>
      <InformationRow title="Date de livraison" value={formatLongDate(carPickUpDate)} />
      {/* <InformationRow
      title='Heure estimée de livraison'
      value={
        'Entre ' +
        deliverySmsMessageTime(clientEstimatedDeliveryDate, -15) +
        ' et ' +
        deliverySmsMessageTime(clientEstimatedDeliveryDate, 15)
      }
    /> */}
    </>
  );
}

export default DateTimeSection;
